export default __webpack_public_path__ + "static/media/13.0c0ab191.jpg";